{% block topdata_contact_login_detail %}
<sw-page class="topdata-contact-login-detail">
    {% block topdata_contact_login_detail_smart_bar_header %}
    <template #smart-bar-header>
        <h2 v-if="contact">
            {{ contactName }}
        </h2>
    </template>
    {% endblock %}

    {% block topdata_contact_login_detail_smart_bar_actions %}
    <template #smart-bar-actions>
        <sw-button
            class="topdata-contact-login-detail__back-button"
            @click="onBack"
        >
            {{ $tc('global.default.back') }}
        </sw-button>
    </template>
    {% endblock %}

    {% block topdata_contact_login_detail_content %}
    <template #content>
        <sw-card-view>
            {% block topdata_contact_login_detail_content_tabs %}
            <sw-tabs
                class="topdata-contact-login-detail__tabs"
                position-identifier="topdata-contact-login-detail-tabs"
            >
                {% block topdata_contact_login_detail_content_tab_details %}
                <sw-tabs-item
                    class="topdata-contact-login-detail__tab-details"
                    :route="detailsRoute"
                    :title="$tc('TopdataContactLoginSW6.contactList.detail.tabs.details')"
                >
                    {{ $tc('TopdataContactLoginSW6.contactList.detail.tabs.details') }}
                </sw-tabs-item>
                {% endblock %}

                {% block tdcl_contact_detail_content_tab_after %}{% endblock %}
            </sw-tabs>
            {% endblock %}

            {% block topdata_contact_login_detail_content_view %}
            <template v-if="isLoading">
                <sw-skeleton variant="detail-bold" />
                <sw-skeleton />
            </template>

            <router-view
                v-else-if="contact"
                v-slot="{ Component }"
            >
                <component
                    :is="Component"
                    :contact="contact"
                    :contact-id="contactId"
                />
            </router-view>

            <sw-empty-state
                v-else
                :title="$tc('TopdataContactLoginSW6.contactList.detail.notFound')"
            />
            {% endblock %}

            {% block tdcl_contact_detail_content_view_after %}{% endblock %}
        </sw-card-view>
    </template>
    {% endblock %}
</sw-page>
{% endblock %}
